import React, { useState, useEffect } from 'react';
import {
    Table,
    Dropdown,
    Row,
    Col,
    Form,
    Button,
    InputGroup,
    Spinner,
} from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import { toast } from 'react-toastify';
import { ReactComponent as ReactMoreIcon } from '../../../../assets/icons/more.svg';
import { StyledPageTitle } from '../../../../styles/pageTitle';
import InterestRateModal from './InterestRateModal';
import InterestRateHttpService from '../../../../services/http/interest-rate-http';
import { StyledTh } from '../../PointData/styles';
import PaymentHttpService from '../../../../services/http/payment-http';

export default function interestRateData(){
    const [selectedRate, setSelectedRate] = useState({});
    const [term, setTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [rates, setRates] = useState<any>([]);
    const [isEdit, setIsEdit] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState<any[]>([]);

    async function getRates() {
        setLoading(true);
        setRates([])
        try {
            const response = await InterestRateHttpService.getInterestRates();
            setRates(response.data.data);
        } catch (error) {
            const err = error as any;
            toast.error(err.message);
        }
        setLoading(false);
    }

    const deleteRate = async (rate: any) => {
        setLoading(true);
        try {
            await InterestRateHttpService.deleteInterestRate(rate.id);
            getRates();
            toast.success('Taxa excluída.');
        } catch (error) {
            const err = error as any;
            toast.error(err.message);
        }
        setLoading(false);
    };

    const getPaymentMethods = async () => {
        try {
            const response = await PaymentHttpService.listPaymentMethods();
            setPaymentMethods(response.data.data);
        } catch (error) {
            setPaymentMethods([]);
        }
    };

    const handleHideModal = () => {
        setSelectedRate({});
        setShowModal(false);
    };

    useEffect(() => {
        getRates();
        getPaymentMethods();
    }, []);

    return (
        <>
            <InterestRateModal
                show={showModal}
                isOpen={setShowModal}
                // eslint-disable-next-line react/jsx-no-bind
                update={getRates}
                selectedRate={selectedRate}
                isEdit={isEdit}
                paymentMethods={paymentMethods}
                onHide={handleHideModal}
            />
            <Row>
                <Col>
                    <StyledPageTitle className="mt-2">Taxas de Juros</StyledPageTitle>
                </Col>
                <Col>
                    <Button
                        className="float-right w-25 m-2"
                        onClick={() => {
                            setIsEdit(false);
                            setShowModal(true);
                        }}
                    >
                        Nova Taxa
                    </Button>
                </Col>
            </Row>
            <Row>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <i className="fas fa-search" />
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        type="text"
                        value={term}
                        onChange={(event) => setTerm(event.target.value)}
                        placeholder="Digite aqui o que procura..."
                    />
                </InputGroup>
            </Row>
            <Row>
                <Table bordered hover size="sm" className="text-center">
                    <thead>
                        <tr>
                            <StyledTh>Nome do meio de pagamento</StyledTh>
                            <StyledTh>Quantidade de Parcelas</StyledTh>
                            <StyledTh>Taxa de Juros (%)</StyledTh>
                            <StyledTh />
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan={4}><Spinner animation="border" /></td></tr>
                        ) : (
                            rates.filter((item: any) =>
                                item.paymentMethod?.name?.toLowerCase().includes(term.toLowerCase()) ||
                                String(item.installment).includes(term) ||
                                String(item.percentage).includes(term)
                            ).map((item: any, index: any) => (
                                <tr key={index}>
                                    <td style={{ padding: 10 }}>
                                        <Highlighter
                                            autoEscape
                                            highlightClassName="highlight-term"
                                            searchWords={[term]}
                                            textToHighlight={item.paymentMethod?.name || ''}
                                        />
                                    </td>
                                    <td>{item.installment}</td>
                                    <td>{item.percentage}</td>
                                    <td>
                                        <Dropdown key="left">
                                            <Dropdown.Toggle
                                                bsPrefix="nexen"
                                                className="mt-n3 mb-n3"
                                                as={Button}
                                                variant="text"
                                            >
                                                <ReactMoreIcon
                                                    fill="#bdbdbd"
                                                    width="10"
                                                    height="20"
                                                />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setSelectedRate(item);
                                                        setShowModal(true);
                                                        setIsEdit(true);
                                                    }}
                                                >
                                                    Editar
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        deleteRate(item);
                                                    }}
                                                >
                                                    Remover
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </Row>
            {rates.length === 0 && (
                <Col md={12} className="text-center">
                    <strong style={{ color: '#adadad' }}>
                        Sem itens para carregar
                    </strong>
                </Col>
            )}
        </>
    );
};

